// extracted by mini-css-extract-plugin
module.exports = {"previewTray":"SharedStyles_previewTray__dxsd7","buttonLink":"SharedStyles_buttonLink__DBBHs","pdfCanvas":"SharedStyles_pdfCanvas__BP3Qj"};